export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/fixture.worker.f2f1ba3f.worker.js");
}
